<template>
   <div class="bg-white forgotPassword">
    <van-nav-bar
    title="找回密码"
    left-text="返回"
    left-arrow
    @click-left="onClickLeft"
    class="margin20-bottom"
    />
    <div class="loginBox">
        <phone class="margin20-bottom" @phoneEmit=phoneEmit :placeholder=phonePholder></phone>
        <password class="margin20-bottom" @pwdEmit=pwdEmit :com_id=pwd :placeholder=pwdPholder></password>
        <password class="margin20-bottom" @pwdEmit=pwdEmit :com_id=againPwd :placeholder=againPwdPholder></password>
        <verification-code @codeEmit=codeEmit class="margin20-bottom" ></verification-code>
        <div class="padding15-top" @click="btnClick">
        <btn :btnCol=btnColor  :btnText=btnText></btn>
        </div>
        <toast ref="toast"></toast>
    </div>
   </div>
</template>

<script>
import Phone from '@/components/input/phone'
import Password from '@/components/input/password'
import VerificationCode from '@/components/input/verificationCode'
import Btn from '@/components/input/button'
import Toast from '@/components/toast/tosatInfo'

import { resetPwd } from '@/model/user/userServe'


// import Banner from '@/components/base/banner'
export default {
  name: 'Home',
  data(){
      return {
          phonePholder:'请输入手机号',
          pwdPholder:'请输入6-16位密码',
          againPwdPholder:"重复输入密码",
          btnText:'注册',
          phoneObj:{},
          codeObj:{},
          pwd:'pwd',
          againPwd:'againPwd',
          pwdObj:{},
          againPwdObg:{},
          btnColor:false
      }
  },
  components: {
    Phone,
    Password,
    VerificationCode,
    Btn,
    Toast
  },
  watch:{
    phoneObj(val){
        if(val.name && this.codeObj.name && this.pwdObj.name && this.againPwdObg.name){
            this.btnColor = true;
        }
    },
    codeObj(val){
        if(val.name && this.pwdObj.name && this.phoneObj.name && this.againPwdObg.name){
            this.btnColor = true;
        }
    },
    pwdObj(val){
        if(val.name && this.codeObj.name && this.phoneObj.name && this.againPwdObg.name){
            this.btnColor = true;
        }
    },
    againPwdObg(val){
        if(val.name && this.codeObj.name && this.phoneObj.name && this.pwdObj.name){
            this.btnColor = true;
        }
    }
  },
  methods: {
    phoneEmit(e){
        this.phoneObj = e;
       
    },
    codeEmit(e){
        this.codeObj = e;
    },
    pwdEmit(e){
      if(e.com_id == "pwd"){
        this.pwdObj = e
      }
      if(e.com_id =="againPwd"){
        this.againPwdObg=e
      }
    },
    btnClick(){
        if(this.phoneObj && !this.phoneObj.phoneFlag){
            return;
        }
        if(this.codeObj && !this.codeObj.codeFlag){
            this.$refs.toast.showToast('验证码格式有误')
            return;
        }
        if(this.pwdObj && !this.pwdObj.pwdFlag){
            this.$refs.toast.showToast('密码格式有误')
            return;
        }
        if(this.againPwdObg && !this.againPwdObg.pwdFlag){
            this.$refs.toast.showToast('密码格式有误')
            return;
        }
        if(this.pwdObj.name != this.againPwdObg.name){
            this.$refs.toast.showToast('密码不一致')
            return;
        }
                
        let params = {
          loginname: this.phoneObj.name, //注册手机号
          pwd:this.pwdObj.name, //注册密码
          code:this.codeObj.name //验证码
        }

        resetPwd(params).then(() =>{
          this.$router.push({
              path:'/login',
              query:{
                  pathLogin:this.$route.query.pathLogin
              }
          })
        }).catch(error => {
            this.$refs.toast.showToast(error.message)
        })
    }

  }
}
</script>
<style scoped lang='less'>
.loginBox{
    width: 100%;
    height: 100%;
    box-sizing: border-box;
    padding: 0 .75rem 0;
}
.forgotPassword{
    width: 100%;
    height: 100%;
}

</style>

